<div class="border border-[var(--border)] rounded-xl p-3 bg-[var(--surface)]">
  <p class="text-[11px] font-bold uppercase tracking-wide text-[var(--faint)] mb-2">
    {{ etiquetaSeccion }} · {{ fotos.length }} tomada(s)
  </p>

  <div class="space-y-2 mb-2">
    @for (etiqueta of etiquetasPreset; track etiqueta) {
      <app-fila-preset
        [etiqueta]="etiqueta"
        [foto]="fotoDePreset(etiqueta)"
        (capturar)="alCapturarPreset(etiqueta, $event)"
        (eliminar)="eliminar.emit($event)"
      />
    }
  </div>

  @if (fotosLibres.length > 0) {
    <div class="space-y-2 mb-2">
      @for (f of fotosLibres; track f.id) {
        <app-fila-foto [foto]="f" (renombrar)="renombrar.emit($event)" (eliminar)="eliminar.emit($event)" />
      }
    </div>
  }

  @if (agregandoLibre()) {
    <app-camara-captura etiqueta="Nueva foto" (foto)="alAgregarLibre($event)" />
  } @else {
    <button type="button" (click)="agregandoLibre.set(true)" [disabled]="seAlcanzoMaximoLibres"
            class="w-full text-[13px] font-semibold py-2 rounded-lg border border-[var(--border)] disabled:opacity-50 disabled:cursor-not-allowed">
      + Agregar otra foto
    </button>
    @if (seAlcanzoMaximoLibres) {
      <p class="text-[11px] mt-1.5 text-center" style="color: var(--text-secondary)">
        Máximo 2 fotos adicionales alcanzado
      </p>
    }
  }
</div>
